// Chat timestamps from the API are tenant-local wall-clock values. Build dates from their
// components so the browser's timezone never shifts them.
export const parseChatTimestamp = (value) => {
  if (!value || typeof value !== 'string') return null;
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
  if (!match) return null;
  const [, y, mo, d, h, mi, s] = match.map(Number);
  return new Date(y, mo - 1, d, h, mi, s || 0);
};

// `Thu, Oct 30, 2025`
export const formatChatDate = (value) => {
  const date = parseChatTimestamp(value);
  if (!date) return '';
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'short', month: 'short', day: 'numeric', year: 'numeric',
  }).format(date);
};

// `8:30 pm`
export const formatChatTime = (value) => {
  const date = parseChatTimestamp(value);
  if (!date) return '';
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const suffix = hours >= 12 ? 'pm' : 'am';
  return `${hours % 12 === 0 ? 12 : hours % 12}:${minutes} ${suffix}`;
};

export const chatDayKey = (value) => (value ? value.slice(0, 10) : '');

const GROUP_WINDOW_MS = 5 * 60 * 1000;

// Consecutive messages from the same sender within 5 minutes on the same day share a header.
export const isSystemMessage = (message) => message?.messageType === 'System';

export const startsNewGroup = (previous, current) => {
  if (!previous) return true;
  if (isSystemMessage(previous) || isSystemMessage(current)) return true;
  if (previous.senderUserTenantId !== current.senderUserTenantId) return true;
  if (chatDayKey(previous.createdAt) !== chatDayKey(current.createdAt)) return true;
  const prev = parseChatTimestamp(previous.createdAt);
  const curr = parseChatTimestamp(current.createdAt);
  if (!prev || !curr) return true;
  return curr - prev > GROUP_WINDOW_MS;
};

const URL_PATTERN = /(https?:\/\/[^\s<]+[^\s<.,:;"')\]!?])/gi;

// Splits plain text into text and link segments. Only http(s) URLs become links.
export const splitLinks = (text) => {
  if (!text) return [];
  const segments = [];
  let lastIndex = 0;
  text.replace(URL_PATTERN, (match, _group, offset) => {
    if (offset > lastIndex) segments.push({ type: 'text', value: text.slice(lastIndex, offset) });
    segments.push({ type: 'link', value: match });
    lastIndex = offset + match.length;
    return match;
  });
  if (lastIndex < text.length) segments.push({ type: 'text', value: text.slice(lastIndex) });
  return segments;
};

export const senderDisplayName = (message) =>
  `${message.senderFirstName || ''} ${message.senderLastName || ''}`.trim() || 'Member';

export const initialsFor = (name) =>
  (name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');
